module.exports = __webpack_public_path__ + "static/media/landing.photo1.a0e89d14.jpg";